import { render, staticRenderFns } from "./TimeInYardCard.vue?vue&type=template&id=61671d84&"
import script from "./TimeInYardCard.vue?vue&type=script&lang=js&"
export * from "./TimeInYardCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports